module.exports = __webpack_public_path__ + "assets/img/34_698_big.98f7ca71.jpg";